import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
// Assuming you will fetch or import your blog content from another file

import { useLocation } from 'react-router-dom';

const Container = styled.div`
  margin: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h1`
  font-size: 2rem;
  color: #333;
`;

const Topic = styled.h2`
  font-size: 1.5rem;
  color: #666;
`;

const ImagePlaceholder = styled.div`

  height: 200px;
  width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
`;

const Content = styled.div`
  margin: 20px 0;
`;

const SubTitle = styled.h3`
  font-size: 1.3rem;
  color: #333;
`;

const Paragraph = styled.p`
  font-size: 1rem;
  color: #333;
`;

const BulletList = styled.ul`
  padding-left: 20px;
`;

const ListItem = styled.li`
  font-size: 1rem;
  color: #333;
`;
const fetchTeamContent = async (team) => {
  try {
    const content = (await import(`./blog/posts/${team}`)).default;
    return content;
  } catch (error) {
    console.error('Failed to load the team content.', error);
    return null; // Return null or some default content
  }
};
export const BlogPostPage = () => {
  const [postContent, setPostContent] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // Extract the last part of the URL path
    const pathParts = location.pathname.split('/');
    const teamName = pathParts[pathParts.length - 1]; // Assume last part is the team name

    (async () => {
      const content = await fetchTeamContent(teamName);
      setPostContent(content);
    })();
  }, [location]); // Reacting to changes in location

  if (!postContent) return <div></div>;

  return (
    <Container>
      <div style={{ maxWidth: '800px' }}>
        <Title>{postContent.title}</Title>
        <Topic>{postContent.topic}</Topic>
        <ImagePlaceholder><img height={200} src={postContent.imageUrl} /></ImagePlaceholder>
        <Content>
          <SubTitle>{postContent.introduction.title}</SubTitle>
          <Paragraph>{postContent.introduction.text}</Paragraph>
          {postContent.sections.map(section => (
            <div key={section.id} style={{marginTop:'60px'}}>
              <SubTitle>{section.title}</SubTitle>
              {section.paragraphs.map((para, index) => (
                <Paragraph key={index}>{para}</Paragraph>
              ))}
              {section.bullets && (
                <BulletList>
                  {section.bullets.map((bullet, index) => (
                    <ListItem key={index}>{bullet}</ListItem>
                  ))}
                </BulletList>
              )}
            </div>
          ))}
        </Content>
      </div>
    </Container>
  );
};
